// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31SUb","comment":"styles_comment__fAZmm"};